import { gql } from 'graphql-tag';

export const getSolutionsSummaryByCourse = gql`
  query osSolutionsSummaryByCourse($sourceCourseId: ID!) {
    osSolutionsSummaryByCourse(sourceCourseId: $sourceCourseId) {
      sourceCourseId
      sections {
        sourceId
        title
        solutions {
          id
          problemNo
        }
      }
    }
  }
`;

export const getSolution = gql`
  query osSolution($id: ID!) {
    osSolution(id: $id) {
      id
      question {
        description
        choices {
          choiceId
          text
          image
        }
      }
      answer {
        ... on OSSolutionFillNumberAnswer {
          value
        }
        ... on OSSolutionMultiSelectAnswer {
          choiceIds
        }
        ... on OSSolutionSingleSelectAnswer {
          choiceId
        }
      }
      solution
      type
    }
  }
`;
